import React, { useEffect, useState } from 'react';

import classnames from 'classnames';

import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';

import NibAsyncAutoComplete from '../../NibAsyncAutoComplete/NibAsyncAutoComplete';
import css from '../nibTable.module.sass';

const AutoCompleteCell = ({
  value: initialValue,
  row,
  column: { id },
  rowToEdit,
  updateMyData,
  forceUpdateRow,
  data: { updateOptions, onClick = false, resetOnUpdate = false },
  options: staticOptions = [],
  getDisplayedValue,
  ...props
}) => {
  let { index, original } = row;
  const [value, setValue] = useState(initialValue);
  const [options, setOptions] = useState(staticOptions);

  const [isError, setError] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isInited, setIsInited] = useState(false);

  const onChange = (val) => {
    updateMyData({ accessor: id, value: val });
    row.values[id] = val;
    if (resetOnUpdate) {
      original[resetOnUpdate] = null;
      row.values[resetOnUpdate] = null;
    }
    setValue(val);
  };

  useEffect(() => {
    if (forceUpdateRow.index === index) {
      if (forceUpdateRow.hasOwnProperty(id)) {
        setValue(forceUpdateRow[id]);
        setError(true);
      }
    }
  }, [forceUpdateRow]);

  useEffect(() => {
    if (isError) {
      setTimeout(function () {
        setError(false);
      }, 2000);
    }
  }, [isError]);

  const handleInput = async (val) => {
    if (updateOptions) {
      setLoading(true);
      let data = await updateOptions(val, original, row.values, updateMyData);
      setOptions(data);
      setLoading(false);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick(original);
    }
  };

  const displayedValue = getDisplayedValue
    ? getDisplayedValue(original)
    : (props.multiple ? value?.map((item) => item.name).join(', ') : value?.name) || 'not set';

  if (rowToEdit.index === index && rowToEdit.status) {
    return (
      <div className={classnames(css.inputCell, isError && css.error)}>
        <IconButton onClick={() => onChange(initialValue)}>
          <CloseIcon style={{ color: '#fff' }} />
        </IconButton>
        <NibAsyncAutoComplete
          options={options}
          loading={isLoading}
          handleInput={handleInput}
          value={value}
          onChange={onChange}
          {...props}
        />
      </div>
    );
  } else {
    return (
      <p
        onClick={handleClick}
        style={{ cursor: onClick ? 'pointer' : 'unset' }}
        className={classnames(isError && css.error)}
      >
        {displayedValue}
      </p>
    );
  }
};

export default AutoCompleteCell;
